import { api } from "./api";

const actions = {
	executeWebSocketAction: (data, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/websocket/action`,
					data,
					onSuccess,
					onFailure
				})
			);
		};
	},
	/* Merge X knowledges */
	mergeKnowledges: (assistantID, uuids, code, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/knowledge/merge/${assistantID}`,
					data: {
						uuids,
						code
					},
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure
				})
			);
		};
	},
	/* Start source process for X sources */
	startFAIQPipeline: (sources, steps = [], onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/sources/pipeline`,
					data: {
						sources,
						steps
					},
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure
				})
			);
		};
	},
	/* Get metadatas filters for page chat */
	getMetadatasFilters: onSuccess => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/faiq/api/v1/metadatas/filters`,
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {}
				})
			);
		};
	},

	/**
	 * Launch a data integrity check (Mongo report immediate, vector result via WS)
	 * @param {String} assistantID
	 * @param {Object} overrides - optional { vectorModel, embeddingsModel } query overrides
	 * @param {Function} onSuccess - receives the immediate (202) Mongo report payload
	 * @param {Function} onFailure
	 */
	dataCheck: (assistantID, onSuccess = () => {}, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/faiq/api/v1/faiq/dataCheck/${assistantID}`,
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure
				})
			);
		};
	},
	/**
	 * Fetch full Mongo documents for items flagged by the data check (drill-down).
	 * @param {String} assistantID
	 * @param {Object} body - { type: "source" | "knowledge", ids: string[] }
	 */
	dataCheckDetails: (assistantID, body, onSuccess = () => {}, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/faiq/dataCheck/${assistantID}/details`,
					data: body,
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure
				})
			);
		};
	},
	/**
	 * Patch the data check anomalies. Mongo phase is synchronous (in the 202
	 * response), vector phase result arrives later on the websocket event
	 * `faiq_data_check_patch_result`.
	 * @param {String} assistantID
	 * @param {Object} body - { sourcesWithoutAsset, knowledgeWithoutSource, missingInVectorDB, orphansInVectorDB }
	 */
	dataCheckPatch: (assistantID, body, onSuccess = () => {}, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/faiq/dataCheck/${assistantID}/patch`,
					data: body,
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure
				})
			);
		};
	}
};

export default actions;
